// import axios from "axios";
// import { useEffect, useRef, useState } from "react";
// import {
//     FiBriefcase,
//     FiEye,
//     FiStar,
//     FiX,
//     FiUser,
//     FiCalendar,
//     FiDownload,
//     FiSearch,
//     FiClipboard
// } from "react-icons/fi";
// import { useNavigate } from "react-router-dom";
// import { API_BASE_URL } from "../utils/config";
// import "./EmployeeDashboard.css";

// const DetailItem = ({ icon, label, value }) => (
//     <div className="flex items-start gap-3">
//         <div className="mt-1 text-blue-500">{icon}</div>
//         <div>
//             <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">{label}</p>
//             <p className="text-sm font-bold text-gray-800">{value}</p>
//         </div>
//     </div>
// );

// const ScheduleInterviews = () => {
//     const [candidates, setCandidates] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState("");
//     const [searchQuery, setSearchQuery] = useState("");
//     const [scoreFilter, setScoreFilter] = useState(0);
//     const [roleFilter, setRoleFilter] = useState("");
//     const [dateFilter, setDateFilter] = useState("");
//     const [roles, setRoles] = useState([]);
//     const [roleSearchQuery, setRoleSearchQuery] = useState("");
//     const [isRoleDropdownOpen, setIsRoleDropdownOpen] = useState(false);
//     const roleDropdownRef = useRef(null);
//     const [selectedCandidate, setSelectedCandidate] = useState(null);
//     const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
//     const [inviteForm, setInviteForm] = useState({
//         subject: "Interview Invitation - Timely Health",
//         time: "",
//         interviewMode: "Online",
//     });

//     const [locations, setLocations] = useState([]);
//     const [isAssessmentModalOpen, setIsAssessmentModalOpen] = useState(false);
//     const [selectedAssessmentData, setSelectedAssessmentData] = useState(null);
//     const [quizzes, setQuizzes] = useState([]);

//     // Pagination states
//     const [pagination, setPagination] = useState({
//         currentPage: 1,
//         totalPages: 1,
//         totalCount: 0,
//         limit: 10,
//     });

//     const navigate = useNavigate();

//     // Get clientId from localStorage
//     const getClientId = () => {
//         return localStorage.getItem('clientId') || localStorage.getItem('clientCustomId') || '';
//     };

//     const clientId = getClientId();

//     useEffect(() => {
//         fetchCandidates();
//         fetchQuizzes();
//         fetchLocations();
//         fetchRoles();

//         const handleClickOutside = (event) => {
//             if (roleDropdownRef.current && !roleDropdownRef.current.contains(event.target)) {
//                 setIsRoleDropdownOpen(false);
//             }
//         };
//         document.addEventListener("mousedown", handleClickOutside);
//         return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, []);

//     const fetchRoles = async () => {
//         try {
//             const clientId = getClientId();
//             let url;
//             if (clientId) {
//                 url = `${API_BASE_URL}/roles/all?clientId=${clientId}`;
//             } else {
//                 url = `${API_BASE_URL}/roles/all`;
//             }
//             const res = await axios.get(url);
//             if (res.data.success) {
//                 const rolesData = res.data.data || [];
//                 const formattedRoles = rolesData.map((role, index) => ({
//                     _id: role._id || index,
//                     name: role.roleName || role.name || role
//                 }));
//                 const uniqueRoles = Array.from(new Set(formattedRoles.map(r => r.name)))
//                     .filter(name => name)
//                     .map(name => formattedRoles.find(r => r.name === name));
//                 setRoles(uniqueRoles);
//             }
//         } catch (err) {
//             console.error("Failed to fetch roles:", err);
//         }
//     };

//     const fetchLocations = async () => {
//         try {
//             const clientId = getClientId();
//             let url;
//             if (clientId) {
//                 url = `${API_BASE_URL}/location/alllocation?clientId=${clientId}`;
//             } else {
//                 url = `${API_BASE_URL}/location/alllocation`;
//             }
//             const res = await axios.get(url);
//             if (res.data?.locations) setLocations(res.data.locations);
//         } catch (err) {
//             console.error("Failed to fetch locations:", err);
//         }
//     };

//     const fetchQuizzes = async () => {
//         try {
//             const clientId = getClientId();
//             let url;
//             if (clientId) {
//                 url = `${API_BASE_URL}/admin/getallquizes/${clientId}`;
//             } else {
//                 url = `${API_BASE_URL}/admin/getallquizes`;
//             }
//             const res = await axios.get(url);
//             if (res.data?.quizzes) setQuizzes(res.data.quizzes);
//         } catch (err) {
//             console.error("Failed to fetch quizzes:", err);
//         }
//     };

//     const fetchCandidates = async () => {
//         try {
//             setLoading(true);
//             const clientId = getClientId();
//             if (!clientId) {
//                 setCandidates([]);
//                 return;
//             }
//             const res = await axios.get(`${API_BASE_URL}/applications/all/${clientId}`);
//             if (res.data.success) {
//                 setCandidates(res.data.applications || []);
//             }
//         } catch (err) {
//             setError("Failed to fetch candidates data");
//             console.error(err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleUpdateScore = async (id, field, value) => {
//         const numericValue = (field === "status") ? value : Number(value);
//         const clientId = getClientId();

//         try {
//             const res = await axios.post(`${API_BASE_URL}/applications/update-score`, {
//                 applicationId: id,
//                 clientId: clientId,
//                 [field]: numericValue,
//             });
//             if (res.data.success) {
//                 setCandidates((prev) =>
//                     prev.map((c) => (c._id === id ? { ...c, [field]: numericValue } : c))
//                 );
//             }
//         } catch (err) {
//             console.error("Update score error:", err);
//         }
//     };

//     const handleOpenInviteModal = (candidate) => {
//         setSelectedCandidate(candidate);
//         setIsInviteModalOpen(true);
//     };

//     const handleSendInvite = async () => {
//         if (!inviteForm.time || !inviteForm.subject) {
//             alert("Please fill in all fields");
//             return;
//         }

//         const clientId = getClientId();

//         try {
//             const res = await axios.post(`${API_BASE_URL}/applications/send-invitation`, {
//                 applicationId: selectedCandidate._id,
//                 clientId: clientId,
//                 interviewSubject: inviteForm.subject,
//                 interviewTime: inviteForm.time,
//                 interviewMode: inviteForm.interviewMode,
//             });

//             if (res.data.success) {
//                 alert("Interview invitation sent successfully!");
//                 setIsInviteModalOpen(false);
//                 fetchCandidates();
//             }
//         } catch (err) {
//             console.error("Send invite error:", err);
//             alert("Failed to send invitation");
//         }
//     };

//     const handleOpenAssessmentDetails = (candidate) => {
//         if (!candidate.assessmentResults || candidate.assessmentResults.length === 0) {
//             alert("No assessment data available for this candidate.");
//             return;
//         }

//         const latest = candidate.assessmentResults[candidate.assessmentResults.length - 1];

//         let matchedQuiz = null;

//         if (latest.quizId && typeof latest.quizId === 'object' && latest.quizId.questions) {
//             matchedQuiz = latest.quizId;
//         } else {
//             const quizId = typeof latest.quizId === 'object' ? latest.quizId?._id : latest.quizId;
//             matchedQuiz = quizzes.find(q => String(q._id) === String(quizId));

//             if (!matchedQuiz && candidate.comment) {
//                 const titleMatch = candidate.comment.match(/"([^"]+)"/);
//                 if (titleMatch?.[1]) {
//                     matchedQuiz = quizzes.find(q => q.title === titleMatch[1]);
//                 }
//             }
//         }

//         let enrichedAnswers = [];

//         if (matchedQuiz && matchedQuiz.questions && matchedQuiz.questions.length > 0) {
//             enrichedAnswers = matchedQuiz.questions.map((q, idx) => {
//                 const storedByText = latest.answers?.find(a => a.questionText === q.questionText);
//                 const storedByIndex = latest.answers?.[idx];
//                 const storedAns = storedByText || storedByIndex;

//                 const selected = storedAns?.selectedOption || "Not Answered";
//                 const correct = q.correctAnswer || "";

//                 return {
//                     questionText: q.questionText,
//                     options: q.options || [],
//                     correctAnswer: correct,
//                     selectedOption: selected,
//                     isCorrect: String(selected).trim() === String(correct).trim(),
//                     marks: q.marks || 1,
//                 };
//             });
//         } else if (latest.answers && latest.answers.length > 0) {
//             enrichedAnswers = latest.answers.map(ans => ({
//                 questionText: ans.questionText || "Question",
//                 options: ans.options?.length > 0
//                     ? ans.options
//                     : [ans.selectedOption, ans.correctAnswer].filter(Boolean),
//                 correctAnswer: ans.correctAnswer || "",
//                 selectedOption: ans.selectedOption || "Not Answered",
//                 isCorrect: ans.isCorrect !== undefined
//                     ? ans.isCorrect
//                     : String(ans.selectedOption).trim() === String(ans.correctAnswer).trim(),
//                 marks: ans.marks || 1
//             }));
//         }

//         setSelectedAssessmentData({
//             ...latest,
//             answers: enrichedAnswers,
//             quizTitle: matchedQuiz?.title || "Assessment"
//         });
//         setSelectedCandidate(candidate);
//         setIsAssessmentModalOpen(true);
//     };

//     const filteredCandidates = candidates.filter(c => {
//         const query = searchQuery.toLowerCase();
//         const matchesSearch = `${c.firstName} ${c.lastName}`.toLowerCase().includes(query) ||
//             (c.jobId?.role || "").toLowerCase().includes(query);

//         const matchesScore = (c.technicalScore || 0) >= scoreFilter;
//         const matchesRole = roleFilter ? (c.jobId?.role === roleFilter) : true;

//         const matchesDate = dateFilter
//             ? new Date(c.appliedAt).toISOString().slice(0, 10) === dateFilter
//             : true;

//         const isInterview = c.status === "Interview";

//         return matchesSearch && matchesScore && matchesRole && matchesDate && isInterview;
//     });

//     // Pagination Handlers
//     const handleItemsPerPageChange = (limit) => {
//         setPagination({
//             currentPage: 1,
//             limit: limit,
//             totalCount: filteredCandidates.length,
//             totalPages: Math.ceil(filteredCandidates.length / limit)
//         });
//     };

//     const handlePrevPage = () => {
//         if (pagination.currentPage > 1) {
//             setPagination(prev => ({
//                 ...prev,
//                 currentPage: prev.currentPage - 1
//             }));
//         }
//     };

//     const handleNextPage = () => {
//         if (pagination.currentPage < pagination.totalPages) {
//             setPagination(prev => ({
//                 ...prev,
//                 currentPage: prev.currentPage + 1
//             }));
//         }
//     };

//     const handlePageClick = (page) => {
//         setPagination(prev => ({
//             ...prev,
//             currentPage: page
//         }));
//     };

//     const getPageNumbers = () => {
//         const pageNumbers = [];
//         for (let i = 1; i <= pagination.totalPages; i++) {
//             if (
//                 i === 1 ||
//                 i === pagination.totalPages ||
//                 (i >= pagination.currentPage - 2 && i <= pagination.currentPage + 2)
//             ) {
//                 pageNumbers.push(i);
//             } else if (i === pagination.currentPage - 3 || i === pagination.currentPage + 3) {
//                 pageNumbers.push("...");
//             }
//         }
//         return pageNumbers;
//     };

//     // Update pagination when filtered results change
//     useEffect(() => {
//         setPagination(prev => ({
//             ...prev,
//             totalCount: filteredCandidates.length,
//             totalPages: Math.ceil(filteredCandidates.length / prev.limit),
//             currentPage: 1
//         }));
//     }, [filteredCandidates.length, searchQuery, scoreFilter, roleFilter, dateFilter]);

//     // Calculate pagination
//     const indexOfLastItem = pagination.currentPage * pagination.limit;
//     const indexOfFirstItem = indexOfLastItem - pagination.limit;
//     const currentItems = filteredCandidates.slice(indexOfFirstItem, indexOfLastItem);

//     const resetFilters = () => {
//         setSearchQuery("");
//         setScoreFilter(0);
//         setRoleFilter("");
//         setRoleSearchQuery("");
//         setDateFilter("");
//     };

//     const handleDownload = () => {
//         const headers = [
//             "Candidate Name",
//             "Email",
//             "Mobile",
//             "Applied Role",
//             "Applied Date",
//             "Assessment Score (100)",
//             "Interview Time",
//             "Interview Mode",
//             "Interview Status",
//             "Experience",
//             "Highest Qualification",
//             "Current CTC",
//             "Expected CTC"
//         ];

//         const csvContent = [
//             headers.join(","),
//             ...filteredCandidates.map(c => [
//                 `"${c.firstName} ${c.lastName}"`,
//                 `"${c.email || "N/A"}"`,
//                 `"${c.mobile || "N/A"}"`,
//                 `"${c.jobId?.role || "N/A"}"`,
//                 `"${new Date(c.appliedAt).toLocaleDateString()}"`,
//                 c.technicalScore || 0,
//                 `"${c.interviewTime ? new Date(c.interviewTime).toLocaleString() : "Not Scheduled"}"`,
//                 `"${c.interviewMode || "N/A"}"`,
//                 `"${c.candidateInterviewStatus || "Pending"}"`,
//                 `"${c.experience || 0}"`,
//                 `"${c.highestQualification || "N/A"}"`,
//                 `"${c.currentCTC || "N/A"}"`,
//                 `"${c.expectedCTC || "N/A"}"`
//             ].join(","))
//         ].join("\n");

//         const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//         const url = URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         const filename = `Scheduled_Interviews_Report_${new Date().toISOString().split('T')[0]}.csv`;
//         link.setAttribute("href", url);
//         link.setAttribute("download", filename);
//         link.style.visibility = 'hidden';
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//     };

//     // Show loading if no clientId
//     if (!clientId) {
//         return (
//             <div className="w-full min-h-screen p-2 flex items-center justify-center">
//                 <div className="text-center">
//                     <div className="w-10 h-10 border-4 border-indigo-50 border-t-indigo-600 rounded-full animate-spin mx-auto mb-4"></div>
//                     <p className="text-gray-600">Please login to view schedule interviews</p>
//                 </div>
//             </div>
//         );
//     }

//     if (loading) return (
//         <div className="emp-dash">
//             <div className="flex flex-col items-center justify-center min-h-[420px] gap-3">
//                 <div className="emp-dash__spinner"></div>
//                 <span className="text-sm font-medium text-gray-500">Loading interview schedule...</span>
//             </div>
//         </div>
//     );

//     return (
//         <div className="emp-dash">
//             <main className="p-4 sm:p-6 lg:p-8">
//                 {/* Dashboard Header */}
//                 <div className="emp-dash__header">
//                     <div>
//                         <h1 className="emp-dash__greeting">
//                             Schedule <span>Interviews</span>
//                         </h1>
//                         <p className="emp-dash__subtitle">
//                             Manage interview schedules and candidate confirmations
//                         </p>
//                     </div>
//                     <div className="emp-dash__date-pill">
//                         <FiClipboard />
//                         <span>
//                             {new Date().toLocaleDateString("en-US", {
//                                 weekday: "short",
//                                 year: "numeric",
//                                 month: "short",
//                                 day: "numeric",
//                             })}
//                         </span>
//                     </div>
//                 </div>
//                 {/* Filters Section */}
//                 <div className="emp-dash__card mb-6">
//                     <div className="emp-dash__card-header">
//                         <div>
//                             <h3 className="emp-dash__card-title flex items-center gap-2">
//                                 <FiSearch className="text-blue-600" /> Filter Candidates
//                             </h3>
//                             <p className="emp-dash__card-desc">Search by name, role, score, or date</p>
//                         </div>
//                     </div>
//                     <div className="emp-dash__card-body bg-gray-50/50">
//                         <div className="flex flex-wrap items-center gap-2">

//                             {/* Search Bar */}
//                             <div className="relative flex-1 min-w-[180px]">
//                                 <FiSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm" />
//                                 <input
//                                     type="text"
//                                     placeholder="Search name or role..."
//                                     value={searchQuery}
//                                     onChange={(e) => setSearchQuery(e.target.value)}
//                                     className="w-full pl-8 pr-3 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                 />
//                             </div>

//                             {/* Role Filter Button */}
//                             <div className="relative" ref={roleDropdownRef}>
//                                 <button
//                                     onClick={() => setIsRoleDropdownOpen(!isRoleDropdownOpen)}
//                                     className={`h-8 px-3 text-xs font-medium rounded-md transition flex items-center gap-1 ${
//                                         roleFilter 
//                                             ? 'bg-blue-600 text-white hover:bg-blue-700' 
//                                             : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300'
//                                     }`}
//                                 >
//                                     <FiBriefcase className="text-xs" /> Role {roleFilter && `: ${roleFilter}`}
//                                 </button>

//                             {/* Role Filter Dropdown */}
//                             {isRoleDropdownOpen && (
//                                 <div className="absolute z-50 mt-1 w-48 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
//                                     <div className="p-2 border-b border-gray-100 bg-gray-50">
//                                         <div className="relative">
//                                             <FiSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs" />
//                                             <input
//                                                 type="text"
//                                                 className="w-full py-1 pl-7 pr-2 text-xs bg-white border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
//                                                 placeholder="Search roles..."
//                                                 value={roleSearchQuery}
//                                                 onChange={(e) => setRoleSearchQuery(e.target.value)}
//                                                 onClick={(e) => e.stopPropagation()}
//                                                 autoFocus
//                                             />
//                                         </div>
//                                     </div>
//                                 <div
//                                     onClick={() => {
//                                         setRoleFilter('');
//                                         setIsRoleDropdownOpen(false);
//                                         setRoleSearchQuery('');
//                                     }}
//                                     className={`px-4 py-2.5 text-xs hover:bg-blue-50 cursor-pointer border-b border-gray-100 font-medium ${!roleFilter ? 'bg-blue-50 text-blue-700' : 'text-gray-700'
//                                         }`}
//                                 >
//                                     All Roles
//                                 </div>
//                                 {roles
//                                     .filter(r => r.name.toLowerCase().includes(roleSearchQuery.toLowerCase()))
//                                     .map((r) => (
//                                         <div
//                                             key={r._id}
//                                             onClick={() => {
//                                                 setRoleFilter(r.name);
//                                                 setIsRoleDropdownOpen(false);
//                                                 setRoleSearchQuery('');
//                                             }}
//                                             className={`px-4 py-2 text-xs hover:bg-blue-50 cursor-pointer ${roleFilter === r.name ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-700'
//                                                 }`}
//                                         >
//                                             {r.name}
//                                         </div>
//                                     ))}
//                                 {roles.filter(r => r.name.toLowerCase().includes(roleSearchQuery.toLowerCase())).length === 0 && (
//                                     <div className="px-3 py-2 text-xs text-gray-400 text-center">
//                                         No roles found
//                                     </div>
//                                 )}
//                             </div>
//                         )}
//                     </div>

//                             {/* Score Filter */}
//                             <div className="relative w-[130px]">
//                                 <select
//                                     className="w-full pl-2 pr-6 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent appearance-none"
//                                     value={scoreFilter}
//                                     onChange={(e) => setScoreFilter(Number(e.target.value))}
//                                 >
//                                     <option value="0">All Scores</option>
//                                     <option value="60">60% & Above</option>
//                                     <option value="70">70% & Above</option>
//                                     <option value="80">80% & Above</option>
//                                     <option value="90">90% & Above</option>
//                                 </select>
//                                 <div className="absolute inset-y-0 right-0 flex items-center pr-1 pointer-events-none">
//                                     <FiStar className="text-[8px] text-gray-400" />
//                                 </div>
//                             </div>

//                             {/* Date Filter */}
//                             <div className="relative w-[130px]">
//                                 <span className="absolute left-2 top-1/2 -translate-y-1/2 text-[10px] text-gray-500 pointer-events-none">
//                                     Date:
//                                 </span>
//                                 <input
//                                     type="date"
//                                     value={dateFilter}
//                                     onChange={(e) => setDateFilter(e.target.value)}
//                                     onClick={(e) => e.target.showPicker && e.target.showPicker()}
//                                     className="w-full pl-12 pr-2 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                 />
//                             </div>

//                             {/* Download Button */}
//                             <button
//                                 onClick={handleDownload}
//                                 className="h-8 px-4 text-[11px] font-black text-white bg-gradient-to-r from-emerald-500 to-teal-600 rounded-md hover:from-emerald-600 hover:to-teal-700 transition shadow-md flex items-center gap-1.5 uppercase tracking-widest ml-auto"
//                             >
//                                 <FiDownload /> Download
//                             </button>

//                             {/* Clear Filters Button */}
//                             {(searchQuery || scoreFilter > 0 || roleFilter || dateFilter) && (
//                                 <button
//                                     onClick={resetFilters}
//                                     className="h-8 px-3 text-xs font-medium text-gray-600 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 transition"
//                                 >
//                                     Clear
//                                 </button>
//                             )}
//                         </div>
//                     </div>
//                 </div>

//                 {error && (
//                     <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-xl flex items-center gap-3">
//                         <FiX className="text-red-500 text-lg" />
//                         <span className="text-sm font-medium text-red-700">{error}</span>
//                     </div>
//                 )}

//                 {/* Job Listings Table */}
//                 <div className="emp-dash__card mb-6">
//                     {filteredCandidates.length > 0 ? (
//                         <div className="emp-dash__table-wrap">
//                             <table className="emp-dash__table">
//                                 <thead>
//                                     <tr>
//                                         <th className="py-2 text-center">Candidate</th>
//                                         <th className="py-2 text-center">Role</th>
//                                         <th className="py-2 text-center">Applied Date</th>
//                                         <th className="py-2 text-center">Assessment (100)</th>
//                                         <th className="py-2 text-center">Interview Schedule</th>
//                                         <th className="py-2 text-center">Confirm Status</th>
//                                         <th className="py-2 text-center">Status</th>
//                                         <th className="py-2 text-center">Actions</th>
//                                     </tr>
//                                 </thead>
//                             <tbody>
//                                 {currentItems.map((c) => (
//                                     <tr key={c._id} className="border-b hover:bg-gray-50 transition-colors">
//                                         <td className="px-2 py-2 font-medium text-center">
//                                             <div className="flex flex-col">
//                                                 <span className="text-gray-900 whitespace-nowrap">{c.firstName} {c.lastName}</span>
//                                             </div>
//                                         </td>
//                                         <td className="px-2 py-2 font-medium text-center">
//                                             <span className="bg-gray-100 text-gray-600 text-[10px] px-2 py-0.5 rounded uppercase ">
//                                                 {c.jobId?.role || "N/A"}
//                                             </span>
//                                         </td>
//                                         <td className="px-2 py-2 font-medium text-center text-xs text-gray-500">
//                                             {new Date(c.appliedAt).toLocaleDateString()}
//                                         </td>
//                                         <td className="px-2 py-2 font-medium text-center">
//                                             <div className="flex items-center justify-center gap-2">
//                                                 <span className="text-xs font-bold text-indigo-600">{c.technicalScore || 0}%</span>
//                                                 {c.assessmentResults && c.assessmentResults.length > 0 && (
//                                                     <button
//                                                         onClick={() => handleOpenAssessmentDetails(c)}
//                                                         className="p-1.5 bg-indigo-50 text-indigo-600 hover:bg-indigo-600 hover:text-white rounded-lg transition-all"
//                                                         title="View Answers"
//                                                     >
//                                                         <FiEye size={12} />
//                                                     </button>
//                                                 )}
//                                             </div>
//                                         </td>
//                                         <td className="px-2 py-2 font-medium text-center">
//                                             {c.interviewTime ? (
//                                                 <div className="flex flex-col items-center">
//                                                     <span className="text-[10px] font-bold text-gray-800">
//                                                         {new Date(c.interviewTime).toLocaleString([], { dateStyle: 'short', timeStyle: 'short' })}
//                                                     </span>
//                                                     <span className="text-[8px] font-black uppercase text-indigo-500 tracking-tighter">
//                                                         {c.interviewMode}
//                                                     </span>
//                                                 </div>
//                                             ) : (
//                                                 <span className="text-[8px] font-black uppercase text-amber-500 bg-amber-50 px-2 py-0.5 rounded">
//                                                     Not Scheduled Yet
//                                                 </span>
//                                             )}
//                                         </td>
//                                         <td className="px-2 py-2 font-medium text-center">
//                                             {c.candidateInterviewStatus ? (
//                                                 <span className={`text-[10px] font-black uppercase px-2 py-1 rounded-full border ${
//                                                     c.candidateInterviewStatus === 'Confirmed' ? 'text-emerald-600 bg-emerald-50 border-emerald-100' :
//                                                     c.candidateInterviewStatus === 'Declined' ? 'text-rose-600 bg-rose-50 border-rose-100' :
//                                                     'text-amber-600 bg-amber-50 border-amber-100'
//                                                 }`}>
//                                                     {c.candidateInterviewStatus}
//                                                 </span>
//                                             ) : (
//                                                 <span className="text-gray-300 text-[10px]">---</span>
//                                             )}
//                                         </td>
//                                         <td className="px-2 py-2 font-medium text-center text-xs">
//                                              <select
//                                                 className={`p-1 border rounded text-[10px]  ${c.status === "Interview" ? "text-blue-600 bg-blue-50" : "text-gray-600"}`}
//                                                 value={c.status || "Pending"}
//                                                 onChange={(e) => handleUpdateScore(c._id, "status", e.target.value)}
//                                             >
//                                                 <option value="Pending">PENDING</option>
//                                                 <option value="Shortlisted">SHORTLISTED</option>
//                                                 <option value="Interview">INTERVIEW</option>
//                                                 <option value="Selected">SELECTED</option>
//                                                 <option value="Rejected">REJECTED</option>
//                                             </select>
//                                         </td>
//                                         <td className="px-2 py-2 font-medium text-center">
//                                             <button
//                                                 onClick={() => handleOpenInviteModal(c)}
//                                                 className="px-4 py-2 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-xl hover:from-blue-600 hover:to-indigo-700 transition-all shadow-md hover:shadow-lg hover:-translate-y-0.5 flex items-center justify-center gap-2 text-[10px] font-black tracking-widest mx-auto"
//                                             >
//                                                 <FiCalendar size={12} />
//                                                 {c.interviewTime ? "RESCHEDULE" : "SCHEDULE"}
//                                             </button>
//                                         </td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>

//                         {/* Pagination */}
//                         {filteredCandidates.length > 0 && (
//                             <div className="flex flex-col items-center justify-between px-4 py-3 border-t border-gray-200 bg-gray-50 sm:flex-row">
//                                 <div className="flex flex-wrap items-center gap-2 text-sm text-gray-700">
//                                     <span>Showing</span>
//                                     <span className="font-medium">
//                                         {indexOfFirstItem + 1}
//                                     </span>
//                                     <span>to</span>
//                                     <span className="font-medium">
//                                         {Math.min(indexOfLastItem, filteredCandidates.length)}
//                                     </span>
//                                     <span>of</span>
//                                     <span className="font-medium">
//                                         {filteredCandidates.length}
//                                     </span>
//                                     <span>results</span>

//                                     <select
//                                         value={pagination.limit}
//                                         onChange={(e) => {
//                                             const newLimit = Number(e.target.value);
//                                             handleItemsPerPageChange(newLimit);
//                                         }}
//                                         className="p-1 ml-2 text-sm border rounded-lg"
//                                     >
//                                         <option value={5}>5</option>
//                                         <option value={10}>10</option>
//                                         <option value={20}>20</option>
//                                         <option value={50}>50</option>
//                                     </select>
//                                 </div>

//                                 <div className="flex items-center gap-2 mt-2 sm:mt-0">
//                                     <button
//                                         onClick={handlePrevPage}
//                                         disabled={pagination.currentPage === 1}
//                                         className={`px-4 py-2 border rounded-lg text-sm font-medium transition-colors ${
//                                             pagination.currentPage === 1
//                                                 ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                                                 : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
//                                         }`}
//                                     >
//                                         Previous
//                                     </button>

//                                     <div className="flex items-center gap-1">
//                                         {getPageNumbers().map((page, index) => (
//                                             <button
//                                                 key={index}
//                                                 onClick={() => typeof page === 'number' ? handlePageClick(page) : null}
//                                                 disabled={page === "..."}
//                                                 className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
//                                                     page === "..."
//                                                         ? "text-gray-500 cursor-default"
//                                                         : pagination.currentPage === page
//                                                         ? "bg-blue-600 text-white"
//                                                         : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50"
//                                                 }`}
//                                             >
//                                                 {page}
//                                             </button>
//                                         ))}
//                                     </div>

//                                     <button
//                                         onClick={handleNextPage}
//                                         disabled={pagination.currentPage === pagination.totalPages}
//                                         className={`px-4 py-2 border rounded-lg text-sm font-medium transition-colors ${
//                                             pagination.currentPage === pagination.totalPages
//                                                 ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                                                 : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
//                                         }`}
//                                     >
//                                         Next
//                                     </button>
//                                 </div>
//                             </div>
//                         )}
//                     </div>
//                 ) : (
//                     <div className="py-10 text-center">
//                         <div className="flex flex-col items-center justify-center gap-3">
//                             <div className="emp-dash__spinner"></div>
//                             <span className="text-sm font-medium text-gray-500">No scheduled interviews found</span>
//                         </div>
//                     </div>
//                 )}
//             </div>
//             </main>

//             {/* Invite/Schedule Modal */}
//             {isInviteModalOpen && (
//                 <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
//                     <div className="bg-white rounded-xl max-w-md w-full p-6 shadow-2xl">
//                         <h2 className="text-xl font-bold mb-4 flex items-center gap-2">
//                              Schedule Interview Session
//                         </h2>
//                         <p className="text-sm text-gray-600 mb-6">
//                             Candidate: <span className="font-black text-indigo-600">{selectedCandidate?.firstName} {selectedCandidate?.lastName}</span>
//                         </p>

//                         <div className="space-y-5">
//                             <div>
//                                 <label className="block text-xs font-black text-gray-500 uppercase mb-1 tracking-wider">Invitation Subject</label>
//                                 <input
//                                     type="text"
//                                     className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-indigo-500 text-sm font-bold bg-gray-50"
//                                     value={inviteForm.subject}
//                                     onChange={(e) => setInviteForm({ ...inviteForm, subject: e.target.value })}
//                                 />
//                             </div>
//                             <div>
//                                 <label className="block text-xs font-black text-gray-500 uppercase mb-1 tracking-wider">Interview Date & Time</label>
//                                 <input
//                                     type="datetime-local"
//                                     className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-indigo-500 text-sm font-bold bg-gray-50"
//                                     value={inviteForm.time}
//                                     onChange={(e) => setInviteForm({ ...inviteForm, time: e.target.value })}
//                                 />
//                             </div>
//                             <div>
//                                 <label className="block text-xs font-black text-gray-500 uppercase mb-1 tracking-wider">Meeting Point / Platform</label>
//                                 <select
//                                     className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-indigo-500 font-bold text-sm bg-gray-50"
//                                     value={inviteForm.interviewMode}
//                                     onChange={(e) => setInviteForm({ ...inviteForm, interviewMode: e.target.value })}
//                                 >
//                                     <option value="Online">🌐 Online (Google Meet / Zoom)</option>
//                                     {locations.map(loc => (
//                                         <option key={loc._id} value={loc.fullAddress}>
//                                             📍 {loc.name} - {loc.fullAddress}
//                                         </option>
//                                     ))}
//                                 </select>
//                             </div>
//                         </div>

//                         <div className="flex justify-end gap-3 mt-8">
//                             <button
//                                 className="px-5 py-2.5 text-xs font-black uppercase text-gray-400 hover:text-gray-600"
//                                 onClick={() => setIsInviteModalOpen(false)}
//                             >
//                                 Cancel
//                             </button>
//                             <button
//                                 className="px-6 py-2.5 bg-indigo-600 text-white rounded-xl hover:bg-indigo-700 shadow-md transform active:scale-95 text-xs font-black uppercase"
//                                 onClick={handleSendInvite}
//                             >
//                                 Confirm Schedule
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* Assessment Detail Modal (Copied from Score.jsx) */}
//             {isAssessmentModalOpen && selectedAssessmentData && (
//                  <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-[2px]">
//                     <div className="bg-white max-w-4xl w-full rounded-2xl shadow-2xl overflow-hidden relative border border-gray-100 max-h-[90vh] flex flex-col">
//                         <div className="px-8 pt-8 pb-6 border-b border-gray-100 flex-shrink-0">
//                             <div className="flex items-start justify-between">
//                                 <div>
//                                     <h2 className="text-xl text-gray-800 font-bold">Assessment Answer Sheet</h2>
//                                     <p className="text-[10px] font-bold uppercase tracking-widest mt-1.5 text-gray-500">
//                                         Candidate: <span className="text-indigo-600">{selectedCandidate?.firstName} {selectedCandidate?.lastName}</span>
//                                     </p>
//                                 </div>
//                                 <button onClick={() => setIsAssessmentModalOpen(false)} className="p-2 hover:bg-gray-100 rounded-xl transition-all">
//                                     <FiX className="text-lg" />
//                                 </button>
//                             </div>
//                         </div>
//                         <div className="p-8 overflow-y-auto space-y-6 flex-grow bg-white">
//                             {selectedAssessmentData.answers?.map((ans, idx) => (
//                                 <div key={idx} className="bg-white rounded-xl border border-gray-200 overflow-hidden">
//                                      <div className="px-5 py-4 border-b border-gray-100 bg-gray-50/50 flex items-center gap-3">
//                                          <span className="w-8 h-8 rounded-lg bg-indigo-100 text-indigo-600 flex items-center justify-center font-bold text-xs">Q{idx+1}</span>
//                                          <p className="text-sm font-bold text-gray-800">{ans.questionText}</p>
//                                      </div>
//                                      <div className="p-5 space-y-2">
//                                          {ans.options?.map((opt, oIdx) => (
//                                              <div key={oIdx} className={`px-4 py-2 rounded-lg border text-xs font-medium ${
//                                                  opt === ans.selectedOption ? (ans.isCorrect ? "bg-emerald-50 border-emerald-200 text-emerald-700" : "bg-rose-50 border-rose-200 text-rose-700") :
//                                                  opt === ans.correctAnswer ? "bg-emerald-50 border-emerald-200 text-emerald-700 border-dashed" : "bg-white border-gray-100"
//                                              }`}>
//                                                  {opt} {opt === ans.selectedOption && " (User Choice)"} {opt === ans.correctAnswer && " (Correct)"}
//                                              </div>
//                                          ))}
//                                      </div>
//                                 </div>
//                             ))}
//                         </div>
//                         <div className="px-8 py-4 border-t border-gray-100 bg-gray-50 flex justify-end">
//                             <button onClick={() => setIsAssessmentModalOpen(false)} className="px-6 py-2.5 bg-white border border-gray-200 text-gray-700 hover:bg-gray-100 rounded-lg font-bold text-xs uppercase tracking-widest transition-all">
//                                 Close Analysis
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default ScheduleInterviews;


import axios from "axios";
import { useEffect, useRef, useState } from "react";
import {
    FiBriefcase,
    FiEye,
    FiStar,
    FiX,
    FiUser,
    FiCalendar,
    FiDownload,
    FiSearch,
    FiClipboard,
    FiClock,
    FiMail,
    FiPhone
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../utils/config";
import "./EmployeeDashboard.css";

const DetailItem = ({ icon, label, value }) => (
    <div className="flex items-start gap-3">
        <div className="mt-1 text-blue-500">{icon}</div>
        <div>
            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">{label}</p>
            <p className="text-sm font-bold text-gray-800">{value}</p>
        </div>
    </div>
);

// Mobile Card Component
const InterviewCard = ({ candidate, handleUpdateScore, handleOpenInviteModal, handleOpenAssessmentDetails, quizzes }) => {
    const isConfirmed = candidate.candidateInterviewStatus === 'Confirmed';
    const isDeclined = candidate.candidateInterviewStatus === 'Declined';
    const isPending = !candidate.candidateInterviewStatus || candidate.candidateInterviewStatus === 'Pending';
    
    return (
        <div className="bg-white rounded-xl border border-gray-200 p-4 mb-3 shadow-sm hover:shadow-md transition-shadow">
            {/* Header */}
            <div className="flex justify-between items-start mb-3">
                <div>
                    <h3 className="font-bold text-gray-900 text-sm">{candidate.firstName} {candidate.lastName}</h3>
                    <span className="inline-block mt-1 bg-gray-100 text-gray-600 text-[10px] px-2 py-0.5 rounded uppercase">
                        {candidate.jobId?.role || "N/A"}
                    </span>
                </div>
                <div className="flex items-center gap-1">
                    <span className={`text-[10px] font-black uppercase px-2 py-1 rounded-full border ${
                        candidate.status === 'Interview' ? 'text-blue-600 bg-blue-50 border-blue-100' :
                        candidate.status === 'Selected' ? 'text-emerald-600 bg-emerald-50 border-emerald-100' :
                        candidate.status === 'Rejected' ? 'text-rose-600 bg-rose-50 border-rose-100' :
                        'text-amber-600 bg-amber-50 border-amber-100'
                    }`}>
                        {candidate.status || "Pending"}
                    </span>
                </div>
            </div>

            {/* Details Grid */}
            <div className="grid grid-cols-2 gap-2 mb-3">
                <div className="bg-gray-50 p-2 rounded-lg">
                    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Applied Date</p>
                    <p className="text-xs font-medium text-gray-700">{new Date(candidate.appliedAt).toLocaleDateString()}</p>
                </div>
                <div className="bg-gray-50 p-2 rounded-lg">
                    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Assessment</p>
                    <div className="flex items-center gap-2">
                        <div className="flex items-center gap-1">
                            <span className="text-[10px] text-gray-500 font-bold">AVG</span>
                            {candidate.assessmentResults && candidate.assessmentResults.length > 0 ? (
                                <span className="w-16 p-1 border rounded text-xs text-center font-bold bg-gray-100 text-gray-800">
                                    {Math.round(candidate.assessmentResults.reduce((sum, res) => sum + (res.score || 0), 0) / candidate.assessmentResults.length)}
                                </span>
                            ) : (
                                <input
                                    type="number"
                                    min="0"
                                    max="100"
                                    data-gramm="false"
                                    spellcheck="false"
                                    className="w-16 p-1 border rounded text-xs text-center font-bold focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50"
                                    value={candidate.technicalScore || 0}
                                    onChange={(e) => handleUpdateScore(candidate._id, "technicalScore", e.target.value)}
                                />
                            )}
                        </div>
                        {candidate.assessmentResults && candidate.assessmentResults.length > 0 ? (
                            <button
                                onClick={() => handleOpenAssessmentDetails(candidate)}
                                className="p-2 bg-indigo-50 text-indigo-600 hover:bg-indigo-600 hover:text-white rounded-xl transition-all duration-300 shadow-sm hover:shadow-md border border-indigo-100 group flex items-center justify-center transform hover:-translate-y-0.5"
                                title="View Answer Sheets"
                            >
                                <FiEye size={14} className="group-hover:scale-110 transition-transform" />
                            </button>
                        ) : (
                            <div className="w-8 h-8 flex items-center justify-center">
                                <span className="text-gray-300">
                                    <FiEye size={14} />
                                </span>
                            </div>
                        )}
                    </div>
                </div>
                <div className="bg-gray-50 p-2 rounded-lg col-span-2">
                    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Interview Schedule</p>
                    {candidate.interviewTime ? (
                        <div>
                            <p className="text-xs font-medium text-gray-700">
                                {new Date(candidate.interviewTime).toLocaleString([], { dateStyle: 'short', timeStyle: 'short' })}
                            </p>
                            <span className="text-[8px] font-black uppercase text-indigo-500">
                                {candidate.interviewMode}
                            </span>
                        </div>
                    ) : (
                        <span className="text-[8px] font-black uppercase text-amber-500 bg-amber-50 px-2 py-0.5 rounded">
                            Not Scheduled Yet
                        </span>
                    )}
                </div>
                <div className="bg-gray-50 p-2 rounded-lg col-span-2">
                    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Confirm Status</p>
                    <span className={`text-[10px] font-black uppercase px-2 py-1 rounded-full border ${
                        isConfirmed ? 'text-emerald-600 bg-emerald-50 border-emerald-100' :
                        isDeclined ? 'text-rose-600 bg-rose-50 border-rose-100' :
                        'text-amber-600 bg-amber-50 border-amber-100'
                    }`}>
                        {candidate.candidateInterviewStatus || "Pending"}
                    </span>
                </div>
            </div>

            {/* Actions */}
            <div className="flex flex-wrap gap-2">
                <button
                    onClick={() => handleOpenInviteModal(candidate)}
                    className="flex-1 px-3 py-2 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-xl hover:from-blue-600 hover:to-indigo-700 transition-all shadow-md flex items-center justify-center gap-2 text-[10px] font-black tracking-widest"
                >
                    <FiCalendar size={12} />
                    {candidate.interviewTime ? "RESCHEDULE" : "SCHEDULE"}
                </button>
                <select
                    className="flex-1 p-2 border rounded-xl text-[10px] font-bold bg-gray-50 focus:ring-2 focus:ring-blue-500 outline-none"
                    value={candidate.status || "Pending"}
                    onChange={(e) => handleUpdateScore(candidate._id, "status", e.target.value)}
                >
                    <option value="Pending">PENDING</option>
                    <option value="Shortlisted">SHORTLISTED</option>
                    <option value="Interview">INTERVIEW</option>
                    <option value="Selected">SELECTED</option>
                    <option value="Rejected">REJECTED</option>
                </select>
            </div>
        </div>
    );
};

const ScheduleInterviews = () => {
    const [candidates, setCandidates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [scoreFilter, setScoreFilter] = useState(0);
    const [roleFilter, setRoleFilter] = useState("");
    const [dateFilter, setDateFilter] = useState("");
    const [roles, setRoles] = useState([]);
    const [roleSearchQuery, setRoleSearchQuery] = useState("");
    const [isRoleDropdownOpen, setIsRoleDropdownOpen] = useState(false);
    const roleDropdownRef = useRef(null);
    const [selectedCandidate, setSelectedCandidate] = useState(null);
    const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
    const [inviteForm, setInviteForm] = useState({
        subject: "Interview Invitation - Timely Health",
        time: "",
        interviewMode: "Online",
    });

    const [locations, setLocations] = useState([]);
    const [isAssessmentModalOpen, setIsAssessmentModalOpen] = useState(false);
    const [selectedAssessmentData, setSelectedAssessmentData] = useState(null);
    const [quizzes, setQuizzes] = useState([]);

    // Pagination states
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalCount: 0,
        limit: 10,
    });

    const navigate = useNavigate();

    // Get clientId from localStorage
    const getClientId = () => {
        return localStorage.getItem('clientId') || localStorage.getItem('clientCustomId') || '';
    };

    const clientId = getClientId();

    useEffect(() => {
        fetchCandidates();
        fetchQuizzes();
        fetchLocations();
        fetchRoles();

        const handleClickOutside = (event) => {
            if (roleDropdownRef.current && !roleDropdownRef.current.contains(event.target)) {
                setIsRoleDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const fetchRoles = async () => {
        try {
            const clientId = getClientId();
            let url;
            if (clientId) {
                url = `${API_BASE_URL}/roles/all?clientId=${clientId}`;
            } else {
                url = `${API_BASE_URL}/roles/all`;
            }
            const res = await axios.get(url);
            if (res.data.success) {
                const rolesData = res.data.data || [];
                const formattedRoles = rolesData.map((role, index) => ({
                    _id: role._id || index,
                    name: role.roleName || role.name || role
                }));
                const uniqueRoles = Array.from(new Set(formattedRoles.map(r => r.name)))
                    .filter(name => name)
                    .map(name => formattedRoles.find(r => r.name === name));
                setRoles(uniqueRoles);
            }
        } catch (err) {
            console.error("Failed to fetch roles:", err);
        }
    };

    const fetchLocations = async () => {
        try {
            const clientId = getClientId();
            let url;
            if (clientId) {
                url = `${API_BASE_URL}/location/alllocation?clientId=${clientId}`;
            } else {
                url = `${API_BASE_URL}/location/alllocation`;
            }
            const res = await axios.get(url);
            if (res.data?.locations) setLocations(res.data.locations);
        } catch (err) {
            console.error("Failed to fetch locations:", err);
        }
    };

    const fetchQuizzes = async () => {
        try {
            const clientId = getClientId();
            let url;
            if (clientId) {
                url = `${API_BASE_URL}/admin/getallquizes/${clientId}`;
            } else {
                url = `${API_BASE_URL}/admin/getallquizes`;
            }
            const res = await axios.get(url);
            if (res.data?.quizzes) setQuizzes(res.data.quizzes);
        } catch (err) {
            console.error("Failed to fetch quizzes:", err);
        }
    };

    const fetchCandidates = async () => {
        try {
            setLoading(true);
            const clientId = getClientId();
            if (!clientId) {
                setCandidates([]);
                return;
            }
            const res = await axios.get(`${API_BASE_URL}/applications/all/${clientId}`);
            if (res.data.success) {
                setCandidates(res.data.applications || []);
            }
        } catch (err) {
            setError("Failed to fetch candidates data");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateScore = async (id, field, value) => {
        const numericValue = (field === "status") ? value : Number(value);
        const clientId = getClientId();

        try {
            const res = await axios.post(`${API_BASE_URL}/applications/update-score`, {
                applicationId: id,
                clientId: clientId,
                [field]: numericValue,
            });
            if (res.data.success) {
                setCandidates((prev) =>
                    prev.map((c) => (c._id === id ? { ...c, [field]: numericValue } : c))
                );
            }
        } catch (err) {
            console.error("Update score error:", err);
        }
    };

    const handleOpenInviteModal = (candidate) => {
        setSelectedCandidate(candidate);
        setIsInviteModalOpen(true);
    };

    const handleSendInvite = async () => {
        if (!inviteForm.time || !inviteForm.subject) {
            alert("Please fill in all fields");
            return;
        }

        const clientId = getClientId();

        try {
            const res = await axios.post(`${API_BASE_URL}/applications/send-invitation`, {
                applicationId: selectedCandidate._id,
                clientId: clientId,
                interviewSubject: inviteForm.subject,
                interviewTime: inviteForm.time,
                interviewMode: inviteForm.interviewMode,
            });

            if (res.data.success) {
                alert("Interview invitation sent successfully!");
                setIsInviteModalOpen(false);
                fetchCandidates();
            }
        } catch (err) {
            console.error("Send invite error:", err);
            alert("Failed to send invitation");
        }
    };

    const handleOpenAssessmentDetails = (candidate) => {
        if (!candidate.assessmentResults || candidate.assessmentResults.length === 0) {
            alert("No assessment data available for this candidate.");
            return;
        }

        const latest = candidate.assessmentResults[candidate.assessmentResults.length - 1];

        let matchedQuiz = null;

        if (latest.quizId && typeof latest.quizId === 'object' && latest.quizId.questions) {
            matchedQuiz = latest.quizId;
        } else {
            const quizId = typeof latest.quizId === 'object' ? latest.quizId?._id : latest.quizId;
            matchedQuiz = quizzes.find(q => String(q._id) === String(quizId));

            if (!matchedQuiz && candidate.comment) {
                const titleMatch = candidate.comment.match(/"([^"]+)"/);
                if (titleMatch?.[1]) {
                    matchedQuiz = quizzes.find(q => q.title === titleMatch[1]);
                }
            }
        }

        let enrichedAnswers = [];

        if (matchedQuiz && matchedQuiz.questions && matchedQuiz.questions.length > 0) {
            enrichedAnswers = matchedQuiz.questions.map((q, idx) => {
                const storedByText = latest.answers?.find(a => a.questionText === q.questionText);
                const storedByIndex = latest.answers?.[idx];
                const storedAns = storedByText || storedByIndex;

                const selected = storedAns?.selectedOption || "Not Answered";
                const correct = q.correctAnswer || "";

                return {
                    questionText: q.questionText,
                    options: q.options || [],
                    correctAnswer: correct,
                    selectedOption: selected,
                    isCorrect: String(selected).trim() === String(correct).trim(),
                    marks: q.marks || 1,
                };
            });
        } else if (latest.answers && latest.answers.length > 0) {
            enrichedAnswers = latest.answers.map(ans => ({
                questionText: ans.questionText || "Question",
                options: ans.options?.length > 0
                    ? ans.options
                    : [ans.selectedOption, ans.correctAnswer].filter(Boolean),
                correctAnswer: ans.correctAnswer || "",
                selectedOption: ans.selectedOption || "Not Answered",
                isCorrect: ans.isCorrect !== undefined
                    ? ans.isCorrect
                    : String(ans.selectedOption).trim() === String(ans.correctAnswer).trim(),
                marks: ans.marks || 1
            }));
        }

        setSelectedAssessmentData({
            ...latest,
            answers: enrichedAnswers,
            quizTitle: matchedQuiz?.title || "Assessment"
        });
        setSelectedCandidate(candidate);
        setIsAssessmentModalOpen(true);
    };

    const filteredCandidates = candidates.filter(c => {
        const query = searchQuery.toLowerCase();
        const matchesSearch = `${c.firstName} ${c.lastName}`.toLowerCase().includes(query) ||
            (c.jobId?.role || "").toLowerCase().includes(query);

        const matchesScore = (c.technicalScore || 0) >= scoreFilter;
        const matchesRole = roleFilter ? (c.jobId?.role === roleFilter) : true;

        const matchesDate = dateFilter
            ? new Date(c.appliedAt).toISOString().slice(0, 10) === dateFilter
            : true;

        const isInterview = c.status === "Interview";

        return matchesSearch && matchesScore && matchesRole && matchesDate && isInterview;
    });

    // Pagination Handlers
    const handleItemsPerPageChange = (limit) => {
        setPagination({
            currentPage: 1,
            limit: limit,
            totalCount: filteredCandidates.length,
            totalPages: Math.ceil(filteredCandidates.length / limit)
        });
    };

    const handlePrevPage = () => {
        if (pagination.currentPage > 1) {
            setPagination(prev => ({
                ...prev,
                currentPage: prev.currentPage - 1
            }));
        }
    };

    const handleNextPage = () => {
        if (pagination.currentPage < pagination.totalPages) {
            setPagination(prev => ({
                ...prev,
                currentPage: prev.currentPage + 1
            }));
        }
    };

    const handlePageClick = (page) => {
        setPagination(prev => ({
            ...prev,
            currentPage: page
        }));
    };

    const getPageNumbers = () => {
        const pageNumbers = [];
        for (let i = 1; i <= pagination.totalPages; i++) {
            if (
                i === 1 ||
                i === pagination.totalPages ||
                (i >= pagination.currentPage - 2 && i <= pagination.currentPage + 2)
            ) {
                pageNumbers.push(i);
            } else if (i === pagination.currentPage - 3 || i === pagination.currentPage + 3) {
                pageNumbers.push("...");
            }
        }
        return pageNumbers;
    };

    // Update pagination when filtered results change
    useEffect(() => {
        setPagination(prev => ({
            ...prev,
            totalCount: filteredCandidates.length,
            totalPages: Math.ceil(filteredCandidates.length / prev.limit),
            currentPage: 1
        }));
    }, [filteredCandidates.length, searchQuery, scoreFilter, roleFilter, dateFilter]);

    // Calculate pagination
    const indexOfLastItem = pagination.currentPage * pagination.limit;
    const indexOfFirstItem = indexOfLastItem - pagination.limit;
    const currentItems = filteredCandidates.slice(indexOfFirstItem, indexOfLastItem);

    const resetFilters = () => {
        setSearchQuery("");
        setScoreFilter(0);
        setRoleFilter("");
        setRoleSearchQuery("");
        setDateFilter("");
    };

    const handleDownload = () => {
        const headers = [
            "Candidate Name",
            "Email",
            "Mobile",
            "Applied Role",
            "Applied Date",
            "Assessment Score (100)",
            "Interview Time",
            "Interview Mode",
            "Interview Status",
            "Experience",
            "Highest Qualification",
            "Current CTC",
            "Expected CTC"
        ];

        const csvContent = [
            headers.join(","),
            ...filteredCandidates.map(c => [
                `"${c.firstName} ${c.lastName}"`,
                `"${c.email || "N/A"}"`,
                `"${c.mobile || "N/A"}"`,
                `"${c.jobId?.role || "N/A"}"`,
                `"${new Date(c.appliedAt).toLocaleDateString()}"`,
                c.technicalScore || 0,
                `"${c.interviewTime ? new Date(c.interviewTime).toLocaleString() : "Not Scheduled"}"`,
                `"${c.interviewMode || "N/A"}"`,
                `"${c.candidateInterviewStatus || "Pending"}"`,
                `"${c.experience || 0}"`,
                `"${c.highestQualification || "N/A"}"`,
                `"${c.currentCTC || "N/A"}"`,
                `"${c.expectedCTC || "N/A"}"`
            ].join(","))
        ].join("\n");

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        const filename = `Scheduled_Interviews_Report_${new Date().toISOString().split('T')[0]}.csv`;
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Show loading if no clientId
    if (!clientId) {
        return (
            <div className="w-full min-h-screen p-2 flex items-center justify-center">
                <div className="text-center">
                    <div className="w-10 h-10 border-4 border-indigo-50 border-t-indigo-600 rounded-full animate-spin mx-auto mb-4"></div>
                    <p className="text-gray-600">Please login to view schedule interviews</p>
                </div>
            </div>
        );
    }

    if (loading) return (
        <div className="emp-dash">
            <div className="flex flex-col items-center justify-center min-h-[420px] gap-3">
                <div className="emp-dash__spinner"></div>
                <span className="text-sm font-medium text-gray-500">Loading interview schedule...</span>
            </div>
        </div>
    );

    return (
        <div className="emp-dash">
            <main className="p-4">
                {/* Dashboard Header */}
                <div className="emp-dash__header">
                    <div>
                        <h1 className="emp-dash__greeting">
                            Schedule <span>Interviews</span>
                        </h1>
                        <p className="emp-dash__subtitle">
                            Manage interview schedules and candidate confirmations
                        </p>
                    </div>
                    <div className="emp-dash__date-pill">
                        <FiClipboard />
                        <span>
                            {new Date().toLocaleDateString("en-US", {
                                weekday: "short",
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                            })}
                        </span>
                    </div>
                </div>
                {/* Filters Section */}
                <div className="emp-dash__card mb-6">
                    <div className="emp-dash__card-header">
                        <div>
                            <h3 className="emp-dash__card-title flex items-center gap-2">
                                <FiSearch className="text-blue-600" /> Filter Candidates
                            </h3>
                            <p className="emp-dash__card-desc">Search by name, role, score, or date</p>
                        </div>
                    </div>
                    <div className="emp-dash__card-body bg-gray-50/50">
                        <div className="flex flex-wrap items-center gap-2">

                            {/* Search Bar */}
                            <div className="relative flex-1 min-w-[180px]">
                                <FiSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm" />
                                <input
                                    type="text"
                                    placeholder="Search name or role..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    className="w-full pl-8 pr-3 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                />
                            </div>

                            {/* Role Filter Button */}
                            <div className="relative" ref={roleDropdownRef}>
                                <button
                                    onClick={() => setIsRoleDropdownOpen(!isRoleDropdownOpen)}
                                    className={`h-8 px-3 text-xs font-medium rounded-md transition flex items-center gap-1 ${
                                        roleFilter 
                                            ? 'bg-blue-600 text-white hover:bg-blue-700' 
                                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300'
                                    }`}
                                >
                                    <FiBriefcase className="text-xs" /> Role {roleFilter && `: ${roleFilter}`}
                                </button>

                            {/* Role Filter Dropdown */}
                            {isRoleDropdownOpen && (
                                <div className="absolute z-50 mt-1 w-48 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
                                    <div className="p-2 border-b border-gray-100 bg-gray-50">
                                        <div className="relative">
                                            <FiSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs" />
                                            <input
                                                type="text"
                                                className="w-full py-1 pl-7 pr-2 text-xs bg-white border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                                placeholder="Search roles..."
                                                value={roleSearchQuery}
                                                onChange={(e) => setRoleSearchQuery(e.target.value)}
                                                onClick={(e) => e.stopPropagation()}
                                                autoFocus
                                            />
                                        </div>
                                    </div>
                                <div
                                    onClick={() => {
                                        setRoleFilter('');
                                        setIsRoleDropdownOpen(false);
                                        setRoleSearchQuery('');
                                    }}
                                    className={`px-4 py-2.5 text-xs hover:bg-blue-50 cursor-pointer border-b border-gray-100 font-medium ${!roleFilter ? 'bg-blue-50 text-blue-700' : 'text-gray-700'
                                        }`}
                                >
                                    All Roles
                                </div>
                                {roles
                                    .filter(r => r.name.toLowerCase().includes(roleSearchQuery.toLowerCase()))
                                    .map((r) => (
                                        <div
                                            key={r._id}
                                            onClick={() => {
                                                setRoleFilter(r.name);
                                                setIsRoleDropdownOpen(false);
                                                setRoleSearchQuery('');
                                            }}
                                            className={`px-4 py-2 text-xs hover:bg-blue-50 cursor-pointer ${roleFilter === r.name ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-700'
                                                }`}
                                        >
                                            {r.name}
                                        </div>
                                    ))}
                                {roles.filter(r => r.name.toLowerCase().includes(roleSearchQuery.toLowerCase())).length === 0 && (
                                    <div className="px-3 py-2 text-xs text-gray-400 text-center">
                                        No roles found
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                            {/* Score Filter */}
                            <div className="relative w-[130px]">
                                <select
                                    className="w-full pl-2 pr-6 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent appearance-none"
                                    value={scoreFilter}
                                    onChange={(e) => setScoreFilter(Number(e.target.value))}
                                >
                                    <option value="0">All Scores</option>
                                    <option value="60">60% & Above</option>
                                    <option value="70">70% & Above</option>
                                    <option value="80">80% & Above</option>
                                    <option value="90">90% & Above</option>
                                </select>
                                <div className="absolute inset-y-0 right-0 flex items-center pr-1 pointer-events-none">
                                    <FiStar className="text-[8px] text-gray-400" />
                                </div>
                            </div>

                            {/* Date Filter */}
                            <div className="relative w-[130px]">
                                <span className="absolute left-2 top-1/2 -translate-y-1/2 text-[10px] text-gray-500 pointer-events-none">
                                    Date:
                                </span>
                                <input
                                    type="date"
                                    value={dateFilter}
                                    onChange={(e) => setDateFilter(e.target.value)}
                                    onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                    className="w-full pl-12 pr-2 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                />
                            </div>

                            {/* Download Button */}
                            <button
                                onClick={handleDownload}
                                className="h-8 px-4 text-[11px] font-black text-white bg-gradient-to-r from-emerald-500 to-teal-600 rounded-md hover:from-emerald-600 hover:to-teal-700 transition shadow-md flex items-center gap-1.5 uppercase tracking-widest ml-auto"
                            >
                                <FiDownload /> <span className="hidden xs:inline">Download</span>
                            </button>

                            {/* Clear Filters Button */}
                            {(searchQuery || scoreFilter > 0 || roleFilter || dateFilter) && (
                                <button
                                    onClick={resetFilters}
                                    className="h-8 px-3 text-xs font-medium text-gray-600 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 transition"
                                >
                                    Clear
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                {error && (
                    <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-xl flex items-center gap-3">
                        <FiX className="text-red-500 text-lg" />
                        <span className="text-sm font-medium text-red-700">{error}</span>
                    </div>
                )}

                {/* Job Listings Table */}
                <div className="emp-dash__card mb-6">
                    {filteredCandidates.length > 0 ? (
                        <>
                            {/* Desktop Table - Hidden on mobile */}
                            <div className="hidden md:block emp-dash__table-wrap overflow-x-auto w-full">
                                <table className="emp-dash__table min-w-[800px] w-full">
                                    <thead>
                                        <tr>
                                            <th className="py-2 text-center">Candidate</th>
                                            <th className="py-2 text-center">Role</th>
                                            <th className="py-2 text-center">Applied Date</th>
                                            <th className="py-2 text-center">Assessment (100)</th>
                                            <th className="py-2 text-center">Interview Schedule</th>
                                            <th className="py-2 text-center">Confirm Status</th>
                                            <th className="py-2 text-center">Status</th>
                                            <th className="py-2 text-center">Actions</th>
                                        </tr>
                                    </thead>
                                <tbody>
                                    {currentItems.map((c) => (
                                        <tr key={c._id} className="border-b hover:bg-gray-50 transition-colors">
                                            <td className="px-2 py-2 font-medium text-center">
                                                <div className="flex flex-col">
                                                    <span className="text-gray-900 whitespace-nowrap">{c.firstName} {c.lastName}</span>
                                                </div>
                                            </td>
                                            <td className="px-2 py-2 font-medium text-center">
                                                <span className="bg-gray-100 text-gray-600 text-[10px] px-2 py-0.5 rounded uppercase ">
                                                    {c.jobId?.role || "N/A"}
                                                </span>
                                            </td>
                                            <td className="px-2 py-2 font-medium text-center text-xs text-gray-500">
                                                {new Date(c.appliedAt).toLocaleDateString()}
                                            </td>
                                            <td className="px-2 py-2 font-medium text-center">
                                                <div className="flex items-center justify-center gap-2">
                                                    <div className="flex items-center gap-1">
                                                        <span className="text-[10px] text-gray-500 font-bold">AVG</span>
                                                        {c.assessmentResults && c.assessmentResults.length > 0 ? (
                                                            <span className="w-16 p-1 border rounded text-xs text-center font-bold bg-gray-100 text-gray-800">
                                                                {Math.round(c.assessmentResults.reduce((sum, res) => sum + (res.score || 0), 0) / c.assessmentResults.length)}
                                                            </span>
                                                        ) : (
                                                            <input
                                                                type="number"
                                                                min="0"
                                                                max="100"
                                                                data-gramm="false"
                                                                spellcheck="false"
                                                                className="w-16 p-1 border rounded text-xs text-center font-bold focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50"
                                                                value={c.technicalScore || 0}
                                                                onChange={(e) => handleUpdateScore(c._id, "technicalScore", e.target.value)}
                                                            />
                                                        )}
                                                    </div>
                                                    {c.assessmentResults && c.assessmentResults.length > 0 ? (
                                                        <button
                                                            onClick={() => handleOpenAssessmentDetails(c)}
                                                            className="p-2 bg-indigo-50 text-indigo-600 hover:bg-indigo-600 hover:text-white rounded-xl transition-all duration-300 shadow-sm hover:shadow-md border border-indigo-100 group flex items-center justify-center transform hover:-translate-y-0.5"
                                                            title="View Answer Sheets"
                                                        >
                                                            <FiEye size={14} className="group-hover:scale-110 transition-transform" />
                                                        </button>
                                                    ) : (
                                                        <div className="w-8 h-8 flex items-center justify-center">
                                                            <span className="text-gray-300">
                                                                <FiEye size={14} />
                                                            </span>
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                            <td className="px-2 py-2 font-medium text-center">
                                                {c.interviewTime ? (
                                                    <div className="flex flex-col items-center">
                                                        <span className="text-[10px] font-bold text-gray-800">
                                                            {new Date(c.interviewTime).toLocaleString([], { dateStyle: 'short', timeStyle: 'short' })}
                                                        </span>
                                                        <span className="text-[8px] font-black uppercase text-indigo-500 tracking-tighter">
                                                            {c.interviewMode}
                                                        </span>
                                                    </div>
                                                ) : (
                                                    <span className="text-[8px] font-black uppercase text-amber-500 bg-amber-50 px-2 py-0.5 rounded">
                                                        Not Scheduled Yet
                                                    </span>
                                                )}
                                            </td>
                                            <td className="px-2 py-2 font-medium text-center">
                                                {c.candidateInterviewStatus ? (
                                                    <span className={`text-[10px] font-black uppercase px-2 py-1 rounded-full border ${
                                                        c.candidateInterviewStatus === 'Confirmed' ? 'text-emerald-600 bg-emerald-50 border-emerald-100' :
                                                        c.candidateInterviewStatus === 'Declined' ? 'text-rose-600 bg-rose-50 border-rose-100' :
                                                        'text-amber-600 bg-amber-50 border-amber-100'
                                                    }`}>
                                                        {c.candidateInterviewStatus}
                                                    </span>
                                                ) : (
                                                    <span className="text-gray-300 text-[10px]">---</span>
                                                )}
                                            </td>
                                            <td className="px-2 py-2 font-medium text-center text-xs">
                                                 <select
                                                    className={`p-1 border rounded text-[10px]  ${c.status === "Interview" ? "text-blue-600 bg-blue-50" : "text-gray-600"}`}
                                                    value={c.status || "Pending"}
                                                    onChange={(e) => handleUpdateScore(c._id, "status", e.target.value)}
                                                >
                                                    <option value="Pending">PENDING</option>
                                                    <option value="Shortlisted">SHORTLISTED</option>
                                                    <option value="Interview">INTERVIEW</option>
                                                    <option value="Selected">SELECTED</option>
                                                    <option value="Rejected">REJECTED</option>
                                                </select>
                                            </td>
                                            <td className="px-2 py-2 font-medium text-center">
                                                <button
                                                    onClick={() => handleOpenInviteModal(c)}
                                                    className="px-4 py-2 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-xl hover:from-blue-600 hover:to-indigo-700 transition-all shadow-md hover:shadow-lg hover:-translate-y-0.5 flex items-center justify-center gap-2 text-[10px] font-black tracking-widest mx-auto"
                                                >
                                                    <FiCalendar size={12} />
                                                    {c.interviewTime ? "RESCHEDULE" : "SCHEDULE"}
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Mobile Cards - Visible on mobile only */}
                        <div className="md:hidden p-4">
                            {currentItems.map((c) => (
                                <InterviewCard 
                                    key={c._id}
                                    candidate={c}
                                    handleUpdateScore={handleUpdateScore}
                                    handleOpenInviteModal={handleOpenInviteModal}
                                    handleOpenAssessmentDetails={handleOpenAssessmentDetails}
                                    quizzes={quizzes}
                                />
                            ))}
                        </div>

                        {/* Pagination */}
                        {filteredCandidates.length > 0 && (
                            <div className="flex flex-col items-center justify-between px-4 py-3 border-t border-gray-200 bg-gray-50 sm:flex-row">
                                <div className="flex flex-wrap items-center gap-2 text-sm text-gray-700">
                                    <span>Showing</span>
                                    <span className="font-medium">
                                        {indexOfFirstItem + 1}
                                    </span>
                                    <span>to</span>
                                    <span className="font-medium">
                                        {Math.min(indexOfLastItem, filteredCandidates.length)}
                                    </span>
                                    <span>of</span>
                                    <span className="font-medium">
                                        {filteredCandidates.length}
                                    </span>
                                    <span>results</span>

                                    <select
                                        value={pagination.limit}
                                        onChange={(e) => {
                                            const newLimit = Number(e.target.value);
                                            handleItemsPerPageChange(newLimit);
                                        }}
                                        className="p-1 ml-2 text-sm border rounded-lg"
                                    >
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={20}>20</option>
                                        <option value={50}>50</option>
                                    </select>
                                </div>

                                <div className="flex items-center gap-2 mt-2 sm:mt-0">
                                    <button
                                        onClick={handlePrevPage}
                                        disabled={pagination.currentPage === 1}
                                        className={`px-4 py-2 border rounded-lg text-sm font-medium transition-colors ${
                                            pagination.currentPage === 1
                                                ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                                                : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                                        }`}
                                    >
                                        Previous
                                    </button>

                                    <div className="flex items-center gap-1">
                                        {getPageNumbers().map((page, index) => (
                                            <button
                                                key={index}
                                                onClick={() => typeof page === 'number' ? handlePageClick(page) : null}
                                                disabled={page === "..."}
                                                className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                                                    page === "..."
                                                        ? "text-gray-500 cursor-default"
                                                        : pagination.currentPage === page
                                                        ? "bg-blue-600 text-white"
                                                        : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50"
                                                }`}
                                            >
                                                {page}
                                            </button>
                                        ))}
                                    </div>

                                    <button
                                        onClick={handleNextPage}
                                        disabled={pagination.currentPage === pagination.totalPages}
                                        className={`px-4 py-2 border rounded-lg text-sm font-medium transition-colors ${
                                            pagination.currentPage === pagination.totalPages
                                                ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                                                : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                                        }`}
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                        )}
                    </>
                ) : (
                    <div className="py-20 text-center">
                        <div className="bg-gray-50 w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4">
                            <FiCalendar className="text-2xl text-gray-200" />
                        </div>
                        <h2 className="text-lg font-bold text-gray-800">No scheduled interviews</h2>
                        <p className="text-xs text-gray-400 mt-1">Try refined search parameters</p>
                    </div>
                )}
            </div>
            </main>

            {/* Invite/Schedule Modal */}
            {isInviteModalOpen && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
                    <div className="bg-white rounded-xl max-w-md w-full p-4 sm:p-6 shadow-2xl max-h-[90vh] overflow-y-auto">
                        <h2 className="text-lg sm:text-xl font-bold mb-4 flex items-center gap-2">
                             Schedule Interview Session
                        </h2>
                        <p className="text-sm text-gray-600 mb-6">
                            Candidate: <span className="font-black text-indigo-600">{selectedCandidate?.firstName} {selectedCandidate?.lastName}</span>
                        </p>

                        <div className="space-y-5">
                            <div>
                                <label className="block text-xs font-black text-gray-500 uppercase mb-1 tracking-wider">Invitation Subject</label>
                                <input
                                    type="text"
                                    className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-indigo-500 text-sm font-bold bg-gray-50"
                                    value={inviteForm.subject}
                                    onChange={(e) => setInviteForm({ ...inviteForm, subject: e.target.value })}
                                />
                            </div>
                            <div>
                                <label className="block text-xs font-black text-gray-500 uppercase mb-1 tracking-wider">Interview Date & Time</label>
                                <input
                                    type="datetime-local"
                                    className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-indigo-500 text-sm font-bold bg-gray-50"
                                    value={inviteForm.time}
                                    onChange={(e) => setInviteForm({ ...inviteForm, time: e.target.value })}
                                />
                            </div>
                            <div>
                                <label className="block text-xs font-black text-gray-500 uppercase mb-1 tracking-wider">Meeting Point / Platform</label>
                                <select
                                    className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-indigo-500 font-bold text-sm bg-gray-50"
                                    value={inviteForm.interviewMode}
                                    onChange={(e) => setInviteForm({ ...inviteForm, interviewMode: e.target.value })}
                                >
                                    <option value="Online">🌐 Online (Google Meet / Zoom)</option>
                                    {locations.map(loc => (
                                        <option key={loc._id} value={loc.fullAddress}>
                                            📍 {loc.name} - {loc.fullAddress}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="flex flex-col sm:flex-row justify-end gap-3 mt-8">
                            <button
                                className="px-5 py-2.5 text-xs font-black uppercase text-gray-400 hover:text-gray-600"
                                onClick={() => setIsInviteModalOpen(false)}
                            >
                                Cancel
                            </button>
                            <button
                                className="px-6 py-2.5 bg-indigo-600 text-white rounded-xl hover:bg-indigo-700 shadow-md transform active:scale-95 text-xs font-black uppercase"
                                onClick={handleSendInvite}
                            >
                                Confirm Schedule
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Assessment Detail Modal (Copied from Score.jsx) */}
            {isAssessmentModalOpen && selectedAssessmentData && (
                 <div className="fixed inset-0 z-[100] flex items-center justify-center p-2 sm:p-4 bg-gray-900/40 backdrop-blur-[2px]">
                    <div className="bg-white max-w-4xl w-full rounded-xl sm:rounded-2xl shadow-2xl overflow-hidden relative border border-gray-100 max-h-[95vh] flex flex-col">
                        <div className="px-4 sm:px-8 pt-6 sm:pt-8 pb-4 sm:pb-6 border-b border-gray-100 flex-shrink-0">
                            <div className="flex flex-wrap items-start justify-between gap-2">
                                <div>
                                    <h2 className="text-lg sm:text-xl text-gray-800 font-bold">Assessment Answer Sheet</h2>
                                    <p className="text-[10px] font-bold uppercase tracking-widest mt-1.5 text-gray-500">
                                        Candidate: <span className="text-indigo-600">{selectedCandidate?.firstName} {selectedCandidate?.lastName}</span>
                                    </p>
                                </div>
                                <button onClick={() => setIsAssessmentModalOpen(false)} className="p-2 hover:bg-gray-100 rounded-xl transition-all">
                                    <FiX className="text-lg" />
                                </button>
                            </div>
                        </div>
                        <div className="p-4 sm:p-8 overflow-y-auto space-y-4 sm:space-y-6 flex-grow bg-white">
                            {selectedAssessmentData.answers?.map((ans, idx) => (
                                <div key={idx} className="bg-white rounded-xl border border-gray-200 overflow-hidden">
                                     <div className="px-4 sm:px-5 py-3 sm:py-4 border-b border-gray-100 bg-gray-50/50 flex flex-wrap items-center gap-2 sm:gap-3">
                                         <span className="w-8 h-8 rounded-lg bg-indigo-100 text-indigo-600 flex items-center justify-center font-bold text-xs flex-shrink-0">Q{idx+1}</span>
                                         <p className="text-xs sm:text-sm font-bold text-gray-800 flex-1">{ans.questionText}</p>
                                     </div>
                                     <div className="p-4 sm:p-5 space-y-2">
                                         {ans.options?.map((opt, oIdx) => (
                                             <div key={oIdx} className={`px-3 sm:px-4 py-2 rounded-lg border text-xs font-medium ${
                                                 opt === ans.selectedOption ? (ans.isCorrect ? "bg-emerald-50 border-emerald-200 text-emerald-700" : "bg-rose-50 border-rose-200 text-rose-700") :
                                                 opt === ans.correctAnswer ? "bg-emerald-50 border-emerald-200 text-emerald-700 border-dashed" : "bg-white border-gray-100"
                                             }`}>
                                                 {opt} {opt === ans.selectedOption && " (User Choice)"} {opt === ans.correctAnswer && " (Correct)"}
                                             </div>
                                         ))}
                                     </div>
                                </div>
                            ))}
                        </div>
                        <div className="px-4 sm:px-8 py-3 sm:py-4 border-t border-gray-100 bg-gray-50 flex justify-end">
                            <button onClick={() => setIsAssessmentModalOpen(false)} className="px-4 sm:px-6 py-2 sm:py-2.5 bg-white border border-gray-200 text-gray-700 hover:bg-gray-100 rounded-lg font-bold text-xs uppercase tracking-widest transition-all">
                                Close Analysis
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ScheduleInterviews;